import { render, staticRenderFns } from "./LogoSmallFl.vue?vue&type=template&id=572f392a&scoped=true&"
import script from "./LogoSmallFl.vue?vue&type=script&lang=js&"
export * from "./LogoSmallFl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572f392a",
  null
  
)

export default component.exports